<template>
  <div class="devPointBox">
    <div class="searchBox">
      <div class="search_box">
        <span> 信息模块类型</span>
        <el-select
          v-model="infoModuleType"
          placeholder="请选择内容"
          @change="infoModuleTypeChange"
        >
          <el-option
            v-for="item in infoModuleTypeList"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </div>
      <div
        class="search_box"
        v-show="infoModuleType == myConst.universalModuleType.dev"
      >
        <span> 信息模块设备</span>
        <el-select
          v-model="infoDevId"
          placeholder="请选择内容"
          @change="moduleChange(true)"
        >
          <el-option
            v-for="item in devList"
            :key="item.id"
            :label="item.devName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div
        class="search_box"
        v-show="infoModuleType == myConst.universalModuleType.control"
      >
        <span> 信息模块控制器</span>
        <el-select
          v-model="infoControlId"
          placeholder="请选择内容"
          @change="moduleChange(false)"
        >
          <el-option
            v-for="item in controlList"
            :key="item.id"
            :label="item.ctlName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="checkBox">
        <div class="checkBoxRight">
          <p>配置信息选择</p>
          <div class="dataPointBox">
            <div v-for="item in configInfoList" :key="item.id">
              <el-checkbox
                :key="item.checked"
                :checked="item.checked"
                :title="item.infoName"
                @change="configInfoChange(item)"
                >{{ item.infoName }}</el-checkbox
              >
              <div class="count" v-show="false">
                <span @click="numJian(item)">-</span>
                <span>{{ item.index }}</span>
                <span @click="numAdd(item)">+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list_box">
      <el-table
        :data="dataList"
        class="my_el_table"
        style="width: 100%"
        height="100%"
        border
        v-loading="loading"
        element-loading-text="加载中，请稍后..."
        element-loading-background="#01232a"
      >
        <el-table-column
          label="ID"
          prop="id"
          width="50"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="配置信息名称"
          prop="infoName"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="记录名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.recordName"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="数据名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.dataName"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="默认值" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.defaultValue"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="数据单位" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.dataUnit"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="转换系数" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.ratio"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="转换截距" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.base"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="分组标记" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.groupSign"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="分组名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.groupName"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="小数长度" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              class="dialog_select"
              v-model="scope.row.decimalLen"
              placeholder="请选择"
            >
              <el-option
                v-for="item in decimalLenList"
                :key="item.infoCode"
                :label="item.infoName"
                :value="item.infoCode"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="排序号" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="text"
              v-model="scope.row.sortNumber"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="图标" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              class="dialog_select"
              v-model="scope.row.icon"
              placeholder="请选择"
            >
              <el-option
                v-for="item in iconList"
                :key="item.infoTag"
                :label="item.infoName"
                :value="item.infoTag"
                :class="[item.infoTag, 'iconfont', 'icon_left']"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="生效标记" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              class="dialog_select"
              v-model="scope.row.enableSign"
              placeholder="请选择"
            >
              <el-option
                v-for="item in enableSignList"
                :key="item.infoCode"
                :label="item.infoName"
                :value="item.infoCode"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              class="dialog_input"
              type="textarea"
              maxlength="100"
              v-model="scope.row.remark"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
      
      <script>
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import fun from "@/util/util";
export default {
  props: {
    staId: {
      type: Number,
      default: 0,
    },
    devList: {
      type: Array,
      default: () => {
        [];
      },
    },
    controlList: {
      type: Array,
      default: () => {
        [];
      },
    },
    decimalLenList: {
      type: Array,
      default: () => {
        [];
      },
    },
    enableSignList: {
      type: Array,
      default: () => {
        [];
      },
    },
    infoModuleTypeList: {
      type: Array,
      default: () => {
        [];
      },
    },
    iconList: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  data() {
    return {
      myConst,
      infoModuleType: "", //信息模块类型选择内容
      infoDevId: "", //信息模块设备选择内容
      infoControlId: "", //信息模块控制选择内容
      configInfoList: [], //静态信息列表
      dataList: [], //数据列表
      loading: false,
    };
  },
  watch: {
    staId(val) {
      if (val) {
        this.dataList = [];
        this.infoModuleTypeChange();
      }
    },
  },
  mounted() {},
  methods: {
    //信息模块类型选择事件
    infoModuleTypeChange() {
      this.configInfoList = [];
      if (fun.isNull(this.infoModuleType)) return;
      if (this.infoModuleType == myConst.universalModuleType.stat) {
        this.loadConfigInfoList(this.staId);
      } else if (
        this.infoModuleType == myConst.universalModuleType.dev &&
        !fun.isNull(this.infoDevId)
      ) {
        this.loadConfigInfoList(this.infoDevId);
      } else if (
        this.infoModuleType == myConst.universalModuleType.control &&
        !fun.isNull(this.infoControlId)
      ) {
        this.loadConfigInfoList(this.infoControlId);
      }
    },

    //信息设备和控制器选择事件
    moduleChange(isDev) {
      this.configInfoList = [];
      if (isDev) {
        this.loadConfigInfoList(this.infoDevId);
      } else {
        this.loadConfigInfoList(this.infoControlId);
      }
    },

    //获取配置信息列表
    loadConfigInfoList(dataId) {
      if (fun.isNull(dataId) || fun.isNull(this.infoModuleType)) return;
      let data = {
        moduleType: this.infoModuleType,
        dataId,
      };
      this.$axios.post(myApi.getConfigInfoBus, data).then((res) => {
        if (res.data.code === myConst.code.success) {
          let list = res.data.data;
          if(this.dataList.length > 0) {
              list.map((x) => {
                x.checked = false;
                x.index = 0;
                this.dataList.forEach(item=>{
                  if(item.id == x.id){
                    x.checked  = true
                    x.index = item.index
                  }
                })
              });
            } else {
              list.map((x) => {
                x.checked = false;
                x.index = 0;
              });
            } 
          this.configInfoList = list;
        } else {
          this.configInfoList = [];
        }
      });
    },

    //静态信息选择事件
    configInfoChange(val) {
      val.checked = !val.checked;
      if (val.checked) {
        this.dataList.push({
          id: val.id,
          codeIndex: -1,
          dataKey: 0,
          devId: 0,
          infoId: val.id,
          infoName: val.infoName,
          recordName: "",
          dataName: val.infoName,
          defaultValue: "",
          dataUnit: val.infoTag,
          ratio: 0,
          base: 0,
          groupSign: 0,
          groupName: "",
          decimalLen: 0,
          sortNumber: 0,
          icon: "",
          enableSign: "0",
          remark: "",
          instantId: 0,
          cumulateId: 0,
          cumulateType: 0,
          checked:val.checked,
          index: val.index,
        });
      } else {
        let findIndex = this.dataList.findIndex((item) => {
          return item.id === val.id;
        });
        if (findIndex >= 0) {
          this.dataList.splice(findIndex, 1);
        }
      }
    },

    //选择点表数据点的个数加1
    numAdd(val) {
      val.index = val.index + 1;
      this.dataList.push({
        id: val.id,
        dataPointName: val.dataName,
        dataKey: val.dataKey,
        codeIndexList: fun.isNull(this.codeIndexMap.get(val.dataKey))
          ? []
          : this.codeIndexMap.get(val.dataKey),
        codeIndex: -1,
        recordName: "",
        dataName: val.dataName,
        defaultValue: "",
        dataUnit: val.dataUnit,
        ratio: 0,
        base: 0,
        groupSign: 0,
        groupName: "",
        decimalLen: 0,
        sortNumber: 0,
        icon: "",
        enableSign: "0",
        remark: "",
        instantId: 0,
        cumulateId: 0,
        cumulateType: 0,
        infoId: 0,
      });
    },

    //选择点表数据点的个数加1
    numJian(val) {
      if (val.index > 0) {
        val.index--;
        let findIndex = this.dataList.findIndex((item) => {
          return item.id === val.id;
        });
        if (findIndex >= 0) {
          this.dataList.splice(findIndex, 1);
        }
      }
      if (val.index == 0) {
        this.$set(val, "checked", false);
        val.index = 0;
      }
    },
  },
};
</script>
      
      <style lang="scss" scoped>
.devPointBox {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  .searchBox {
    width: 17.5%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    box-sizing: border-box;
    border: solid 0.1rem #00fcf9;
    clip-path: polygon(
      1.5rem 0,
      calc(100% - 1.5rem) 0,
      100% 1.5rem,
      100% calc(100% - 1.5rem),
      calc(100% - 1.5rem) 100%,
      1.5rem 100%,
      0 calc(100% - 1.5rem),
      0 1.5rem
    );
    /* 实现四个切角 */
    background: linear-gradient(-45deg, #00fcf9 1.1rem, transparent 0) bottom
        right,
      linear-gradient(45deg, #00fcf9 1.1rem, transparent 0) bottom left,
      linear-gradient(135deg, #00fcf9 1.1rem, transparent 0) top left,
      linear-gradient(-135deg, #00fcf9 1.1rem, transparent 0) top right;
    background-size: 50% 50%;
    background-repeat: no-repeat;
    .search_box {
      display: flex;
      align-items: center;
      margin-left: 4rem;
      margin-left: 0rem;
      text-align: center;
      span {
        width: 10rem;
        text-align: left;
      }
      .el-select {
        width: 15rem;
      }
    }
    .checkBox {
      flex: 1;
      width: 100%;
      display: flex;
      justify-content: space-between;
      .checkBoxRight {
        display: flex;
        flex-direction: column;
        // width: 48%;
        flex: 1;
        //   padding-left: 1rem;
        box-sizing: border-box;
        position: relative;
        p {
          width: 100%;
          height: 3rem;
        }
        .dataPointBox {
          padding-left: 2rem;
          box-sizing: border-box;
          width: 100%;
          position: absolute;
          top: 3rem;
          bottom: 0;
          right: 1rem;
          left: 0rem;
          overflow: auto;
          div {
            display: flex;
            justify-content: space-between;
            margin-bottom: 1rem;
            margin-right: 0.5rem;
            height: 2rem;
            line-height: 2rem;
            .el-checkbox {
              display: flex;
              color: #00dafc;
              font-size: 1.4rem;
              margin: 0;
              width: 72%;
              ::v-deep .el-checkbox__label {
                flex-grow: 1;
                /*1. 先强制一行内显示文本*/
                white-space: nowrap;
                /*2. 超出的部分隐藏*/
                overflow: hidden;
                /*3. 文字用省略号替代超出的部分*/
                text-overflow: ellipsis;
                font-size: 1.4rem;
              }
            }

            .el-checkbox:hover {
              color: #dfc822;
            }
            ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
              color: #dfc822;
            }
            ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
              // background-color:transparent;
              background-color: rgba(225, 225, 0, 0.8);
              border-color: #dfc822;
            }
            .count {
              width: 22%;
              display: flex;
              justify-content: center;
              align-items: center;
              span:nth-child(1) {
                cursor: pointer;
                display: block;
                height: 1.5rem;
                width: 1.5rem;
                line-height: 1.5rem;
                text-align: center;
                border-radius: 50%;
                background-color: #d0d1d3;
                color: #606266;
              }
              span:nth-child(1):hover {
                color: #00dafc;
              }
              span:nth-child(2) {
                padding: 0 0.5rem;
                box-sizing: border-box;
                color: #00dafc;
              }
              span:nth-child(3) {
                cursor: pointer;
                display: block;
                height: 1.5rem;
                width: 1.5rem;
                line-height: 1.5rem;
                text-align: center;
                border-radius: 50%;
                background-color: #d0d1d3;
                color: #606266;
              }
              span:nth-child(3):hover {
                color: #00dafc;
              }
            }
          }
        }
      }
    }
  }
  .list_box {
    position: absolute;
    left: 18%;
    width: 82.5%;
    height: 100%;
  }
}
::v-deep.icon_left > span {
  margin-left: 1rem;
}
::v-deep .el-switch__label {
  color: #00dafc;
}
::v-deep .dialog_select {
  width: 100%;
}
::v-deep .dialog_select .el-input {
  width: 100%;
}
::v-deep .dialog_select .el-input__inner {
  border: none;
}
::v-deep .dialog_input {
  width: 100%;
}
::v-deep .dialog_input .el-input__inner {
  border: none;
}
::v-deep .el-textarea__inner {
  border: none;
}
::v-deep .el-table .cell {
  padding: 0 0.1rem;
  box-sizing: border-box;
}
::-webkit-scrollbar {
  width: 0.2rem;
  background-color: rgba(0, 0, 0, 0.3);
}
::v-deep .el-table .cell {
  height: 3rem;
  line-height: 3rem;
}
</style>